import api from './api'
import { PaginationResponse } from '../types/api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

export interface EmailTemplate {
  id: string
  type: string
  name: string
  subject: string
  htmlContent: string
  textContent?: string
  description?: string
  variables?: any
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface EmailTemplateFormValues {
  name?: string
  subject?: string
  htmlContent?: string
  textContent?: string
  description?: string
  isActive?: boolean
}

type ListParams = {
  search?: string
  isActive?: boolean
  page?: number
  limit?: number
}

export type AdminEmailTemplateListResponse = {
  templates: EmailTemplate[]
  pagination: PaginationResponse
}

const adminEmailTemplateService = {
  async list(params: ListParams = {}): Promise<AdminEmailTemplateListResponse> {
    const { search, isActive, page, limit } = params

    const queryParams: Record<string, unknown> = {}

    if (search) queryParams.search = search
    if (isActive !== undefined) queryParams.isActive = isActive
    if (page) queryParams.page = page
    if (limit) queryParams.limit = limit

    const response = await api.get<ApiSuccessResponse<AdminEmailTemplateListResponse>>(
      '/admin/email-templates',
      { params: queryParams }
    )

    return response.data.data
  },

  async getById(templateId: string): Promise<EmailTemplate> {
    const response = await api.get<ApiSuccessResponse<EmailTemplate>>(
      `/admin/email-templates/${templateId}`
    )

    return response.data.data
  },

  async getByType(type: string): Promise<EmailTemplate> {
    const response = await api.get<ApiSuccessResponse<EmailTemplate>>(
      `/admin/email-templates/type/${type}`
    )

    return response.data.data
  },

  async update(
    templateId: string,
    data: EmailTemplateFormValues
  ): Promise<EmailTemplate> {
    const response = await api.put<ApiSuccessResponse<EmailTemplate>>(
      `/admin/email-templates/${templateId}`,
      data
    )

    return response.data.data
  },

  async updateStatus(
    templateId: string,
    isActive: boolean
  ): Promise<EmailTemplate> {
    const response = await api.patch<ApiSuccessResponse<EmailTemplate>>(
      `/admin/email-templates/${templateId}/status`,
      { isActive }
    )

    return response.data.data
  }
}

export default adminEmailTemplateService

